// returns a binder to switch visibility of an element
export default function display(switcher) {
  if (switcher === void 0) {
    switcher = true;
  }
  return {
    on: null,
    getValue: function getValue() {
      var value = this.style.display || window.getComputedStyle(this).getPropertyValue('display');
      var none = value === 'none';
      return switcher ? !none : none;
    },
    setValue: function setValue(value) {
      var style = this.style;
      if (typeof switcher === 'function') {
        style.display = switcher(value) ? '' : 'none';
      } else if (switcher) {
        style.display = value ? '' : 'none';
      } else {
        style.display = value ? 'none' : '';
      }
    }
  };
}